/**
 * 参考区（色块草稿 / 参考图）文案注册表。
 *
 * 归属：被 Explore 面板（LayoutReference）与作品详情（空间 / 图片详情弹窗）共同消费，
 * 因此下沉到 src/constants 作为单一来源；新增基座只在此登记，禁止在各调用方写分支。
 * 埋点 sketch_type 沿用历史枚举文案「1-线稿 / 2-色块」，与页面展示文案解耦。
 */
export interface SketchTypeLabels {
  /** 参考区标题：色块草稿 / 参考图 / 创意草图 */
  sectionTitle: string;
  line: string;
  color: string;
  /** 浮层标题与正文 */
  lineHelpTitle: string;
  colorHelpTitle: string;
  lineHelpBody: string;
  colorHelpBody: string;
}

const HELP_LINE =
  '把上传的成品图转换成线稿图，参考线稿图，或者直接上传线稿图进行生成';
const HELP_COLOR = '参考上传的成品图进行生成';

/** A3：参考图 / 线稿参考 / 原图参考 */
export const A3_SKETCH_TYPE_LABELS: SketchTypeLabels = {
  sectionTitle: '参考图',
  line: '线稿参考',
  color: '原图参考',
  lineHelpTitle: '线稿参考',
  colorHelpTitle: '原图参考',
  lineHelpBody: HELP_LINE,
  colorHelpBody: HELP_COLOR,
};

/** A1 / A2(Flux)：沿用草图文案 */
export const LEGACY_SKETCH_TYPE_LABELS: SketchTypeLabels = {
  sectionTitle: '色块草稿',
  line: '线稿草图',
  color: '色块草图',
  lineHelpTitle: '线稿草图',
  colorHelpTitle: '色块草图',
  lineHelpBody: HELP_LINE,
  colorHelpBody: HELP_COLOR,
};

/** 非 Flux/A3 的创意草图标题（保持现网） */
export const CREATIVE_SKETCH_SECTION_TITLE = '创意草图';

export function resolveSketchTypeLabels(ckptType?: string | null): SketchTypeLabels {
  if (ckptType === 'A3') return A3_SKETCH_TYPE_LABELS;
  return LEGACY_SKETCH_TYPE_LABELS;
}

/** 参考区标题：A3=参考图 / Flux=色块草稿 / 其余创意草图 */
export function resolveLayoutSectionTitle(ckptType?: string | null, isFlux?: boolean): string {
  if (ckptType === 'A3') return A3_SKETCH_TYPE_LABELS.sectionTitle;
  if (isFlux || ckptType === 'Flux') return LEGACY_SKETCH_TYPE_LABELS.sectionTitle;
  return CREATIVE_SKETCH_SECTION_TITLE;
}

/**
 * 埋点 sketch_type：沿用历史枚举文案（与页面「线稿参考/原图参考」解耦）。
 * Explore / 自由画布共用，保证神策分组口径连续。
 */
export function mapSketchTypeForTracking(sketchType: number): string {
  return sketchType === 1 ? '1-线稿' : '2-色块';
}
